import React, { useEffect, useState } from "react";
import { useSelector } from 'react-redux'
import { useHistory, useLocation } from "react-router-dom";
import {AccessRights} from "lib/constants/accessRights";
import LoadingComponent from "components/loading";
import MainPageComponent from "./main.component";
import qs from "query-string";
import { ORDER_LIST_PAGE } from "modules/stockflow/config/stockflow.route";
import { getLang } from "app/feature/constants";
import {canAccess} from "../../../../profile/redux/selector/profile.selector";

function MainPageContainer() {
  const hasStockflowViewAccessRight = useSelector(state =>
    canAccess(state, AccessRights.TrackcoPortal.ORDER_READ));
  const lang = useSelector(state => state.constant.languages)
  const history = useHistory()
  const location = useLocation()
  const [activeIndex, setActiveIndex] = useState(null);

  const qsParams = qs.parse(location.search);
  const currentSearch = qsParams.status || '';

  useEffect(() => {
    if(!hasStockflowViewAccessRight){
      history.push('/admin/dashboard')
    }
  }, [history, hasStockflowViewAccessRight])

  useEffect(() => {
    let tempIndex= 0
    switch(currentSearch) {
      case "new": 
        tempIndex = 0
        break;
      case "accepted": 
        tempIndex = 1
        break;
      case "rejected": 
        tempIndex = 2
        break;
      case "cancelled": 
        tempIndex = 3
        break;
      default:
        tempIndex = 0
    }
    setActiveIndex(tempIndex)
  }, [currentSearch])

  if(!hasStockflowViewAccessRight) return <LoadingComponent />;

  let tabLabels = []
  if(hasStockflowViewAccessRight){
    tabLabels.push(getLang(lang, "label.NEW_ORDER"))
    tabLabels.push(getLang(lang, "label.ACCEPTED"))
    tabLabels.push(getLang(lang, "label.REJECTED"))
    tabLabels.push(getLang(lang, "label.CANCELLED"))
  }

  const handleChange = (event, index) => {
    if (activeIndex !== index) {
      setActiveIndex(index);
      history.replace({
        pathname: ORDER_LIST_PAGE,
        search: `?status=${index === 0 ? 'new' 
          : index === 1 ? 'accepted' 
          : index === 2 ? 'rejected' 
          : 'cancelled'}`
      })
    }
  };

  return (
    <>
      <MainPageComponent
        handleChange={handleChange}
        activeIndex={activeIndex}
        tabLabels={tabLabels}
        lang={lang}
      />
    </>
  );
}

export default MainPageContainer;
